import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { LazyImage, styled } from '@teko/ds-desktop';
import { t } from './i18n.es.js';

var noProductsFoundImage = "https://shopfront-cdn.tekoapis.com/static/e536f0592aa3c8b1.png";

const NoProductsFound = (_a) => {
    var { text, show } = _a, props = __rest(_a, ["text", "show"]);
    text = text || t('Không tìm thấy sản phẩm nào');
    if (!show)
        return null;
    return (jsxs(Wrapper, Object.assign({}, props, { children: [jsx(LazyImage, { width: 200, height: 200, contain: true, src: noProductsFoundImage }, void 0), jsx(Text, { children: text }, void 0)] }), void 0));
};
const Wrapper = styled.div `
  margin-top: 8rem;
  text-align: center;
`;
const Text = styled.div `
  margin-top: 1.5rem;
  font-size: 1rem;
`;

export { NoProductsFound as N };
